var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreviewEye = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/24/eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07584 11.118C2.83914 6.8523 7.14514 4 12 4C16.8549 4 21.1609 6.8523 22.9242 11.118C23.0709 11.3515 23.0709 11.6485 22.9242 11.882C21.1609 16.1477 16.8549 19 12 19C7.14514 19 2.83914 16.1477 1.07584 11.882C0.974719 11.6374 0.974719 11.3626 1.07584 11.118ZM3.09249 11.5C4.63974 14.8029 8.09967 17 12 17C15.9003 17 19.3603 14.8029 20.9075 11.5C19.3603 8.1971 15.9003 6 12 6C8.09967 6 4.63974 8.1971 3.09249 11.5ZM12.0171 15.3027C9.80881 15.3027 8.0171 13.511 8.0171 11.3027C8.0171 9.09445 9.80881 7.30273 12.0171 7.30273C14.2254 7.30273 16.0171 9.09445 16.0171 11.3027C16.0171 13.511 14.2254 15.3027 12.0171 15.3027ZM12.0171 13.3027C13.1208 13.3027 14.0171 12.4064 14.0171 11.3027C14.0171 10.199 13.1208 9.30273 12.0171 9.30273C10.9134 9.30273 10.0171 10.199 10.0171 11.3027C10.0171 12.4064 10.9134 13.3027 12.0171 13.3027Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreviewEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/preview-eye.3b72959ba6e86d9a2d4471d577aeeffe.svg";